/**
 * OrbDocTutorialsBeginnerTaskManagerAROrbDocTutorialsBeginnerTaskManagerARPage
 *
 * Page component for OrbDocTutorialsBeginnerTaskManagerAROrbDocTutorialsBeginnerTaskManagerARPage
 * Path: /ar/docs/tutorials/beginner/task-manager
 *
 * @generated from schema
 */

import React from 'react';
import { useLocation } from 'react-router-dom';
import type { EventPayload } from '@almadar/core';
import { OrbDocTutorialsBeginnerTaskManagerARDocScreenView as __OrbDocTutorialsBeginnerTaskManagerARDocScreenView } from '@/components/traits/OrbDocTutorialsBeginnerTaskManagerARDocScreenView';
import { OrbDocTutorialsBeginnerTaskManagerARDocAnalyticsView as __OrbDocTutorialsBeginnerTaskManagerARDocAnalyticsView } from '@/components/traits/OrbDocTutorialsBeginnerTaskManagerARDocAnalyticsView';
import { VStack, UISlotComponent } from '@almadar/ui/components';
import { usePageHead } from '@almadar/ui/hooks';

interface OrbDocTutorialsBeginnerTaskManagerAROrbDocTutorialsBeginnerTaskManagerARPageProps {
  // Add any page-level props here
}

export function OrbDocTutorialsBeginnerTaskManagerAROrbDocTutorialsBeginnerTaskManagerARPage(_props: OrbDocTutorialsBeginnerTaskManagerAROrbDocTutorialsBeginnerTaskManagerARPageProps) {
  const __location = useLocation();
  const __navState = (__location.state ?? {}) as EventPayload;

  usePageHead({ "title":"ابنِ مدير مهام","description":"صفوف مخزّنة، ونموذج يضيف صفًا، وإجراءات صف تُكمل وتحذف، وقائمة تُعاد تحميلها بعد كل كتابة.","access":"public","indexing":"index","origin":"https://orb.almadar.io","siteName":"Orb","alternates":[{"locale":"en","path":"/docs/tutorials/beginner/task-manager"},{"locale":"ar","path":"/ar/docs/tutorials/beginner/task-manager"},{"locale":"sl","path":"/sl/docs/tutorials/beginner/task-manager"}],"defaultLocale":"en", path: __location.pathname });

  return (
    <>
      <UISlotComponent slot="main">
        <VStack gap="lg" className="w-full">
          <__OrbDocTutorialsBeginnerTaskManagerARDocScreenView config={{ initPayload: __navState }} />
          <__OrbDocTutorialsBeginnerTaskManagerARDocAnalyticsView config={{ initPayload: __navState }} />
        </VStack>
      </UISlotComponent>
    </>
  );
}

export default OrbDocTutorialsBeginnerTaskManagerAROrbDocTutorialsBeginnerTaskManagerARPage;
